/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ComponentProps, ReactNode } from "react";
import { ErrorWrap } from "./ErrorWrap";
import { LoaderWrap } from "./LoaderWrap";

type ErrorWrapProps = ComponentProps<typeof ErrorWrap>;
type LoaderWrapProps<T = Record<string, never>> = ComponentProps<
  typeof LoaderWrap<T>
>;

type Props<LoaderProps> = {
  children: ReactNode;
  loaderProps: Omit<LoaderWrapProps<LoaderProps>, "children">;
  errorProps: ErrorWrapProps;
};

export function UniversalWrap<LoaderProps = Record<string, unknown>>({
  children,
  loaderProps,
  errorProps,
}: Props<LoaderProps>) {
  return (
    <LoaderWrap {...loaderProps}>
      <ErrorWrap {...errorProps}>{children}</ErrorWrap>
    </LoaderWrap>
  );
}
